export default function updateDataAttributes(element: JQuery<Node>, attrs: Record<string, unknown>) {
    //apply data attributes to jquery data property
    //this allows setting javascript functions or variables as data attributes
    //useful for validation
    for(const [key, value] of Object.entries(attrs)) {
        if((key === 'rules') && value && (typeof value === 'object')) {
            for(const [key2, value2] of Object.entries(value)) {
                //jquery accepts either camelcase or dashed lower case
                //don't include dash into your rule names
                //validator:
                //"rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase()
                //jquery:
                //`rule-${key2.toLowerCase()}`
                const _key = `rule${key2.charAt(0).toUpperCase()}${key2.substring(1).toLowerCase()}`;
                if(!value2) {
                    element.removeData(_key);
                } else {
                    element.data(_key, value2);
                }
            }
        } else if(!value) {
            element.removeData(key);
        } else {
            element.data(key, value);
        }
    }
}
